module.exports = __webpack_public_path__ + "static/media/face-detection- (5).43af03d9.jpg";